import { sendGTMEvent } from '@next/third-parties/google'

export const gtmLogout = () => {
  const uuid = crypto.randomUUID()

  sendGTMEvent({
    event: 'logout',
    event_id: uuid,
    is_user_logged_in: false,
  })
}
